import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CompanyFeatures } from '@app/models/company-features.model';
import { RoleName } from '@app/models/user-role.model';
import { Globals } from '../globals/globals';

/**
 * RESTRICT_PROFILE_ACCESS closes the org chart to employees as well as their colleagues' profiles,
 * since the chart lays out who reports to whom across the whole company. Managers and admins keep
 * it: which profiles they can open from it is ProfileAccessGuard's call, not this one's.
 */
export const canViewOrgChart = (globals: Globals): boolean =>
  !globals.hasFeature(CompanyFeatures.RESTRICT_PROFILE_ACCESS) || globals.hasMinimumAccessLevelOf(RoleName.MANAGER);

@Injectable()
export class OrgChartAccessGuard implements CanActivate {

  constructor(
    private globals: Globals,
    private router: Router
  ) { }

  public canActivate(): boolean {
    if (canViewOrgChart(this.globals)) { return true; }

    this.router.navigate(['/org-chart/restricted']).then();
    return false;
  }
}
